module.exports = __webpack_public_path__ + "img/join_ad_animals_desktop-eb.b7ba3ead.png";